var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStracciatella = function SvgStracciatella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stracciatella_svg__a)",
    d: "M103 83v103.635c0 10.7 14.327 19.365 32 19.365s32-8.67 32-19.365V83l-32-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stracciatella_svg__b)",
    d: "M135 102c17.673 0 32-8.507 32-19s-14.327-19-32-19-32 8.507-32 19 14.327 19 32 19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stracciatella_svg__c)",
    d: "M117 83v15.708a50.86 50.86 0 0 0 36 0V83l-18-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stracciatella_svg__d)",
    d: "M135 94c9.941 0 18-4.925 18-11s-8.059-11-18-11-18 4.925-18 11 8.059 11 18 11"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stracciatella_svg__a",
    x1: 103,
    x2: 167,
    y1: 144,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3C9AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#64AED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stracciatella_svg__b",
    x1: 135,
    x2: 135,
    y1: 100.556,
    y2: 63.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3C9AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#64AED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stracciatella_svg__c",
    x1: 135,
    x2: 135,
    y1: 82.98,
    y2: 190.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1C89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#2F93C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#409CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#56A7CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#71B5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#92C6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#B7DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stracciatella_svg__d",
    x1: 135,
    x2: 135,
    y1: 93.164,
    y2: 65.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3C9AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#64AED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgStracciatella;